const defaultValues = {
    // Basic Details
    name: "",
    description: "",
    type: "Residential",
    salesmanName: null,
    secondarySalesmanName: "",
    hasSecondarySalesman: false,
    leadSource: null,
    secondaryLead: "",
    // Customer Details
    customerName: "",
    customerPhoneNumber: "",
    customerEmail: "",
    customerStreetAddress: "",
    customerCity: "",
    customerState: "",
    customerZipCode: "",
    customerCountry: "Denver County",
    // Property Details
    evorderid: "",
    noEagleViewId: false,
    copyAddressFromCustomer: false,
    propertyStreetAddress: "",
    propertyCity: "",
    propertyState: "",
    propertyZipCode: "",
    propertyCountry: "Denver County",
    // Date Estimation
    inspectionDate: "",
    estimateDate: "",
    permitSubmissionDate: "",
    materialPurchaseDate: "",
    jobStartDate: "",
    estimatedEndDate: "",
    // Insurance Details
    insuranceProvider: "",
    policyNumber: "",
    claimNumber: "",
    adjusterContact: "",
    adjusterEmail: "",
    noInsurance: false,
    // Manual Measurements (when no EagleView ID)
    measurementArea: "",
    measurementRidge: "",
    measurementHip: "",
    measurementValley: "",
    measurementEave: "",
    measurementRake: "",
};

const steps = [
    {
        label: "Basic Information",
        fields: [
            "name",
            "description",
            "type",
            "leadSource",
            "secondaryLead",
            "salesmanName",
            "hasSecondarySalesman",
            "secondarySalesmanName",
        ],
    },
    {
        label: "Customer Details",
        fields: [
            "customerName",
            "customerPhoneNumber",
            "customerEmail",
            "customerStreetAddress",
            "customerCity",
            "customerState",
            "customerZipCode",
            "customerCountry",
        ],
    },
    {
        label: "Property Details",
        fields: [
            "evorderid",
            "propertyStreetAddress",
            "propertyCity",
            "propertyState",
            "propertyZipCode",
            "propertyCountry",
        ],
    },
    {
        label: "Estimate Dates",
        fields: [
            "inspectionDate",
            "estimateDate",
            "permitSubmissionDate",
            "materialPurchaseDate",
            "jobStartDate",
            "estimatedEndDate",
        ],
    },
    {
        label: "Insurance Details",
        fields: ["insuranceProvider", "policyNumber", "claimNumber", "adjusterContact", "adjusterEmail"],
    },
];

export { steps, defaultValues };
